import { Avatar, Box, Tooltip, Typography, styled } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectUserStatus } from '../features/Auth/authSlice';
import { statusOptions } from '../constants/statusOptions';
import React, { useMemo, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import gatewayLogo from '../assets/gatewaylogo.jpeg'
const StyledLazyLoadImage = styled(LazyLoadImage)(({ theme, variant, sx }) => ({
  ...sx,
  objectFit: 'cover',
  width: theme.spacing(5),
  height: theme.spacing(5),
  borderRadius: variant === 'circle' ? '50%' : '4px',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: theme.typography.pxToRem(24),
  color: theme.palette.text.primary,
}));

const UserAvatar = React.memo(({ src, blur = false, size = null, sx = {}, empCode, showStatus = false, ...props }) => {
  const userStatus = useSelector((state) => selectUserStatus(state, empCode));
    const user = useSelector(selectCurrentUser);
  const statusOption = useMemo(() => {
    return statusOptions.find((option) => option.value === userStatus);
  }, [userStatus]);
  const avatarSrc = useMemo(() => {

    console.log("current User Data ",src)
    return src ? `${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${src}` : ['marcome', 'sports_social_celebration', 'learning_development'].includes(user?.username) ? gatewayLogo : null;
  }, [src, user?.username]);



  // console.log("current User Data :--",user,src)
  return (
    <>
      {showStatus && userStatus != 'invisible' ? (
        <Box sx={{ position: 'relative', display: 'inline-block', ...sx }}>
          <Avatar src={src} sx={sx} {...props} />
          <Tooltip title={statusOption?.label || 'Offline'}>
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: 12,
                height: 12,
                borderRadius: '50%',
                backgroundColor: statusOption?.color || 'lightgray',
                border: '2px solid white',
              }}
            />
          </Tooltip>
        </Box>
      ) : blur ? (
        <StyledLazyLoadImage
          src={avatarSrc}
          effect="blur"
          sx={sx}
          wrapperClassName="avatar-wrapper"
          threshold={100}
          visibleByDefault={avatarSrc === null}
          {...props}
        />
      ) : (
        <Avatar src={avatarSrc} sx={sx} {...props} />
      )}
    </>
  );
});

export default UserAvatar;

// CACHED DB

// import { Avatar, Box, Tooltip } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { selectUserStatus } from '../features/Auth/authSlice';
// import { statusOptions } from '../constants/statusOptions';
// import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
// import { cacheImage, getCachedImage } from '../app/api/indexDB';

// const UserAvatar = React.memo(({ src, size = null, sx = {}, empCode, showStatus = false, ...props }) => {
//   const [cachedAvatar, setCachedAvatar] = useState(null);

//   const userStatus = useSelector((state) => selectUserStatus(state, empCode));

//   useLayoutEffect(() => {
//     if (!src) return;
//     const fetchAvatar = async () => {
//       const cachedImage = await getCachedImage(src);
//       if (cachedImage) {
//         const objectURL = URL.createObjectURL(cachedImage);
//         setCachedAvatar(objectURL);
//       } else {
//         try {
//           const response = await fetch(`${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${src}`);
//           const imageBlob = await response.blob();
//           await cacheImage(src, imageBlob); // Cache the image
//           const objectURL = URL.createObjectURL(imageBlob);
//           setCachedAvatar(objectURL);
//         } catch (error) {
//           console.error('Failed to fetch and store avatar image', error);
//         }
//       }
//     };

//     fetchAvatar();
//   }, [src]);

//   const statusOption = useMemo(() => {
//     return statusOptions.find((option) => option.value === userStatus);
//   }, [userStatus]);

//   console.log('render u');
//   return (
//     <>
//       {showStatus && userStatus != 'invisible' ? (
//         <Box sx={{ position: 'relative', display: 'inline-block', ...sx }}>
//           <Avatar src={cachedAvatar || ''} sx={sx} {...props} />
//           <Tooltip title={statusOption?.label || 'Offline'}>
//             <Box
//               sx={{
//                 position: 'absolute',
//                 bottom: 0,
//                 right: 0,
//                 width: 12,
//                 height: 12,
//                 borderRadius: '50%',
//                 backgroundColor: statusOption?.color || 'lightgray',
//                 border: '2px solid white',
//               }}
//             />
//           </Tooltip>
//         </Box>
//       ) : (
//         <Avatar src={cachedAvatar || ''} sx={sx} {...props} />
//       )}
//     </>
//   );
// });

// export default UserAvatar;
